import { render, staticRenderFns } from "./DropdownModal.vue?vue&type=template&id=dfa2a920&"
import script from "./DropdownModal.vue?vue&type=script&lang=js&"
export * from "./DropdownModal.vue?vue&type=script&lang=js&"
import style0 from "./DropdownModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports